import ConsultingRequestForm from "../../components/consulting/ConsultingRequestForm";

export default function ConsultancyRequestPage() {
  return (
    <main className="mx-auto max-w-6xl px-4 py-8">
      <ConsultingRequestForm />
    </main>
  );
}
